import { useRouter } from "next/router";
import { renderHTML } from "util/DomHelper";
import { preformContentLinkClick } from "../util/url/preformContentLinkClick";

function CmsContent(props: any) {
  const router = useRouter();
  const { content, ...rest } = props;

  function handleContentClick(e: any) {
    preformContentLinkClick(router, e);
  }
  return (
    <div
      onClick={handleContentClick}
      onKeyPress={handleContentClick}
      dangerouslySetInnerHTML={renderHTML(content)}
      {...rest}
    />
  );
}

export default CmsContent;
